import { set } from '@ember/object';
import RouterScroll from 'ember-router-scroll/services/router-scroll';

export default RouterScroll.extend({
  update() {
    if (this.key) {
      let bmContent = document.querySelector('.bm-content');
      if (bmContent) {
        set(this.scrollMap, this.key, { x: 0, y: bmContent.scrollTop });
      }
    }
  },
});
